import { FileEdit, Warning } from "@/components/icons";
import { tr, ru, enUS as en, de, es, fr } from "date-fns/locale";
import {
  RiBankCardLine,
  RiBankLine,
  RiBtcLine,
  RiCalendarCheckLine,
  RiCashLine,
  RiCheckboxCircleFill,
  RiCloseCircleFill,
  RiCommunityLine,
  RiCoupon3Line,
  RiErrorWarningFill,
  RiFileList3Line,
  RiHistoryLine,
  RiPercentLine,
  RiVipDiamondLine,
} from "@remixicon/react";
import { MaintenanceScheduleType } from "./types";

export const locales = {
  "tr-TR": tr,
  tr: tr,
  "ru-RU": ru,
  ru: ru,
  "en-US": en,
  en: en,
  "de-DE": de,
  de: de,
  "es-ES": es,
  es: es,
  "fr-FR": fr,
  fr: fr,
};

export const localePathMap = {
  "tr-TR": "tr",
  tr: "tr",
  "en-US": "en",
  en: "en",
  "ru-RU": "ru",
  ru: "ru",
  "de-DE": "de",
  de: "de",
  "es-ES": "es",
  es: "es",
  "fr-FR": "fr",
  fr: "fr",
};

export interface PhoneCodesWithFlags {
  name: string;
  dial_code: string;
  code: string;
  flag: string;
  id: string;
}

export const phoneCodesWithFlags: PhoneCodesWithFlags[] = [
  {
    name: "ABD Virgin Adaları",
    dial_code: "+1 340",
    code: "VI",
    flag: "🇻🇮",
    id: "U.S. Virgin Islands",
  },
  { name: "Almanya", dial_code: "+49", code: "DE", flag: "🇩🇪", id: "Germany" },
  {
    name: "Amerika Birleşik Devletleri",
    dial_code: "+1",
    code: "US",
    flag: "🇺🇸",
    id: "United States",
  },
  { name: "Andora", dial_code: "+376", code: "AD", flag: "🇦🇩", id: "Andorra" },
  { name: "Angola", dial_code: "+244", code: "AO", flag: "🇦🇴", id: "Angola" },
  {
    name: "Anguilla",
    dial_code: "+1 264",
    code: "AI",
    flag: "🇦🇮",
    id: "Anguilla",
  },
  {
    name: "Antarktika",
    dial_code: "+672",
    code: "AQ",
    flag: "🇦🇶",
    id: "Antarctica",
  },
  {
    name: "Antigua ve Barbuda",
    dial_code: "+1268",
    code: "AG",
    flag: "🇦🇬",
    id: "Antigua and Barbuda",
  },
  {
    name: "Arjantin",
    dial_code: "+54",
    code: "AR",
    flag: "🇦🇷",
    id: "Argentina",
  },
  {
    name: "Arnavutluk",
    dial_code: "+355",
    code: "AL",
    flag: "🇦🇱",
    id: "Albania",
  },
  { name: "Aruba", dial_code: "+297", code: "AW", flag: "🇦🇼", id: "Aruba" },
  {
    name: "Avustralya",
    dial_code: "+61",
    code: "AU",
    flag: "🇦🇺",
    id: "Australia",
  },
  {
    name: "Avusturya",
    dial_code: "+43",
    code: "AT",
    flag: "🇦🇹",
    id: "Austria",
  },
  {
    name: "Azerbaycan",
    dial_code: "+994",
    code: "AZ",
    flag: "🇦🇿",
    id: "Azerbaijan",
  },
  {
    name: "Bahamalar",
    dial_code: "+1 242",
    code: "BS",
    flag: "🇧🇸",
    id: "Bahamas",
  },
  { name: "Bahreyn", dial_code: "+973", code: "BH", flag: "🇧🇭", id: "Bahrain" },
  {
    name: "Bangladeş",
    dial_code: "+880",
    code: "BD",
    flag: "🇧🇩",
    id: "Bangladesh",
  },
  {
    name: "Barbados",
    dial_code: "+1 246",
    code: "BB",
    flag: "🇧🇧",
    id: "Barbados",
  },
  { name: "Belize", dial_code: "+501", code: "BZ", flag: "🇧🇿", id: "Belize" },
  { name: "Belçika", dial_code: "+32", code: "BE", flag: "🇧🇪", id: "Belgium" },
  { name: "Benin", dial_code: "+229", code: "BJ", flag: "🇧🇯", id: "Benin" },
  {
    name: "Bermuda",
    dial_code: "+1 441",
    code: "BM",
    flag: "🇧🇲",
    id: "Bermuda",
  },
  {
    name: "Beyaz Rusya",
    dial_code: "+375",
    code: "BY",
    flag: "🇧🇾",
    id: "Belarus",
  },
  { name: "Bhutan", dial_code: "+975", code: "BT", flag: "🇧🇹", id: "Bhutan" },
  {
    name: "Birleşik Arap Emirlikleri",
    dial_code: "+971",
    code: "AE",
    flag: "🇦🇪",
    id: "United Arab Emirates",
  },
  {
    name: "Birleşik Krallık",
    dial_code: "+44",
    code: "GB",
    flag: "🇬🇧",
    id: "United Kingdom",
  },
  { name: "Bolivya", dial_code: "+591", code: "BO", flag: "🇧🇴", id: "Bolivia" },
  {
    name: "Bosna Hersek",
    dial_code: "+387",
    code: "BA",
    flag: "🇧🇦",
    id: "Bosnia and Herzegovina",
  },
  {
    name: "Botsvana",
    dial_code: "+267",
    code: "BW",
    flag: "🇧🇼",
    id: "Botswana",
  },
  { name: "Brezilya", dial_code: "+55", code: "BR", flag: "🇧🇷", id: "Brazil" },
  { name: "Brunei", dial_code: "+673", code: "BN", flag: "🇧🇳", id: "Brunei" },
  {
    name: "Bulgaristan",
    dial_code: "+359",
    code: "BG",
    flag: "🇧🇬",
    id: "Bulgaria",
  },
  {
    name: "Burkina Faso",
    dial_code: "+226",
    code: "BF",
    flag: "🇧🇫",
    id: "Burkina Faso",
  },
  { name: "Burundi", dial_code: "+257", code: "BI", flag: "🇧🇮", id: "Burundi" },
  {
    name: "Cape Verde",
    dial_code: "+238",
    code: "CV",
    flag: "🇨🇻",
    id: "Cape Verde",
  },
  {
    name: "Cebelitarık",
    dial_code: "+350",
    code: "GI",
    flag: "🇬🇮",
    id: "Gibraltar",
  },
  { name: "Cezayir", dial_code: "+213", code: "DZ", flag: "🇩🇿", id: "Algeria" },
  { name: "Cibuti", dial_code: "+253", code: "DJ", flag: "🇩🇯", id: "Djibouti" },
  {
    name: "Cook Adaları",
    dial_code: "+682",
    code: "CK",
    flag: "🇨🇰",
    id: "Cook Islands",
  },
  { name: "Çad", dial_code: "+235", code: "TD", flag: "🇹🇩", id: "Chad" },
  {
    name: "Çek Cumhuriyeti",
    dial_code: "+420",
    code: "CZ",
    flag: "🇨🇿",
    id: "Czech Republic",
  },
  { name: "Çin", dial_code: "+86", code: "CN", flag: "🇨🇳", id: "China" },
  {
    name: "Danimarka",
    dial_code: "+45",
    code: "DK",
    flag: "🇩🇰",
    id: "Denmark",
  },
  {
    name: "Dominik",
    dial_code: "+1 767",
    code: "DM",
    flag: "🇩🇲",
    id: "Dominica",
  },
  {
    name: "Dominik Cumhuriyeti",
    dial_code: "+1 849",
    code: "DO",
    flag: "🇩🇴",
    id: "Dominican Republic",
  },
  {
    name: "Doğu Timor",
    dial_code: "+670",
    code: "TL",
    flag: "🇹🇱",
    id: "Timor-Leste",
  },
  { name: "Ekvator", dial_code: "+593", code: "EC", flag: "🇪🇨", id: "Ecuador" },
  {
    name: "Ekvator Ginesi",
    dial_code: "+240",
    code: "GQ",
    flag: "🇬🇶",
    id: "Equatorial Guinea",
  },
  {
    name: "El Salvador",
    dial_code: "+503",
    code: "SV",
    flag: "🇸🇻",
    id: "El Salvador",
  },
  {
    name: "Endonezya",
    dial_code: "+62",
    code: "ID",
    flag: "🇮🇩",
    id: "Indonesia",
  },
  { name: "Eritre", dial_code: "+291", code: "ER", flag: "🇪🇷", id: "Eritrea" },
  {
    name: "Ermenistan",
    dial_code: "+374",
    code: "AM",
    flag: "🇦🇲",
    id: "Armenia",
  },
  { name: "Estonya", dial_code: "+372", code: "EE", flag: "🇪🇪", id: "Estonia" },
  {
    name: "Etiyopya",
    dial_code: "+251",
    code: "ET",
    flag: "🇪🇹",
    id: "Ethiopia",
  },
  {
    name: "Faroe Adaları",
    dial_code: "+298",
    code: "FO",
    flag: "🇫🇴",
    id: "Faroe Islands",
  },
  { name: "Fas", dial_code: "+212", code: "MA", flag: "🇲🇦", id: "Morocco" },
  { name: "Fiji", dial_code: "+679", code: "FJ", flag: "🇫🇯", id: "Fiji" },
  {
    name: "Fildişi Sahilleri",
    dial_code: "+225",
    code: "CI",
    flag: "🇨🇮",
    id: "Ivory Coast",
  },
  {
    name: "Filipinler",
    dial_code: "+63",
    code: "PH",
    flag: "🇵🇭",
    id: "Philippines",
  },
  {
    name: "Filistin Bölgesi",
    dial_code: "+970",
    code: "PS",
    flag: "🇵🇸",
    id: "Palestine",
  },
  {
    name: "Finlandiya",
    dial_code: "+358",
    code: "FI",
    flag: "🇫🇮",
    id: "Finland",
  },
  { name: "Fransa", dial_code: "+33", code: "FR", flag: "🇫🇷", id: "France" },
  {
    name: "Fransız Guyanası",
    dial_code: "+594",
    code: "GF",
    flag: "🇬🇫",
    id: "French Guiana",
  },
  {
    name: "Fransız Polinezyası",
    dial_code: "+689",
    code: "PF",
    flag: "🇵🇫",
    id: "French Polynesia",
  },
  { name: "Gabon", dial_code: "+241", code: "GA", flag: "🇬🇦", id: "Gabon" },
  { name: "Gambia", dial_code: "+220", code: "GM", flag: "🇬🇲", id: "Gambia" },
  { name: "Gana", dial_code: "+233", code: "GH", flag: "🇬🇭", id: "Ghana" },
  { name: "Gine", dial_code: "+224", code: "GN", flag: "🇬🇳", id: "Guinea" },
  {
    name: "Gine-Bissau",
    dial_code: "+245",
    code: "GW",
    flag: "🇬🇼",
    id: "Guinea-Bissau",
  },
  {
    name: "Granada",
    dial_code: "+1 473",
    code: "GD",
    flag: "🇬🇩",
    id: "Grenada",
  },
  {
    name: "Grönland",
    dial_code: "+299",
    code: "GL",
    flag: "🇬🇱",
    id: "Greenland",
  },
  {
    name: "Guadeloupe",
    dial_code: "+590",
    code: "GP",
    flag: "🇬🇵",
    id: "Guadeloupe",
  },
  { name: "Guam", dial_code: "+1 671", code: "GU", flag: "🇬🇺", id: "Guam" },
  {
    name: "Guatemala",
    dial_code: "+502",
    code: "GT",
    flag: "🇬🇹",
    id: "Guatemala",
  },
  { name: "Guyana", dial_code: "+595", code: "GY", flag: "🇬🇾", id: "Guyana" },
  {
    name: "Güney Afrika",
    dial_code: "+27",
    code: "ZA",
    flag: "🇿🇦",
    id: "South Africa",
  },
  {
    name: "Güney Kore",
    dial_code: "+82",
    code: "KR",
    flag: "🇰🇷",
    id: "South Korea",
  },
  {
    name: "Güney Kıbrıs Rum Kesimi",
    dial_code: "+537",
    code: "CY",
    flag: "🇨🇾",
    id: "South Cyprus",
  },
  {
    name: "Gürcistan",
    dial_code: "+995",
    code: "GE",
    flag: "🇬🇪",
    id: "Georgia",
  },
  { name: "Haiti", dial_code: "+509", code: "HT", flag: "🇭🇹", id: "Haiti" },
  { name: "Hindistan", dial_code: "+91", code: "IN", flag: "🇮🇳", id: "India" },
  {
    name: "Hint Okyanusu İngiliz Bölgesi",
    dial_code: "+246",
    code: "IO",
    flag: "🇮🇴",
    id: "British Indian Ocean Territory",
  },
  {
    name: "Hollanda",
    dial_code: "+31",
    code: "NL",
    flag: "🇳🇱",
    id: "Netherlands",
  },
  {
    name: "Hollanda Antilleri",
    dial_code: "+599",
    code: "AN",
    flag: "",
    id: "Netherlands Antilles",
  },
  {
    name: "Honduras",
    dial_code: "+504",
    code: "HN",
    flag: "🇭🇳",
    id: "Honduras",
  },
  {
    name: "Hong Kong SAR - Çin",
    dial_code: "+852",
    code: "HK",
    flag: "🇭🇰",
    id: "Hong Kong",
  },
  {
    name: "Hırvatistan",
    dial_code: "+385",
    code: "HR",
    flag: "🇭🇷",
    id: "Croatia",
  },
  { name: "Irak", dial_code: "+964", code: "IQ", flag: "🇮🇶", id: "Iraq" },
  {
    name: "İngiliz Virgin Adaları",
    dial_code: "+1 284",
    code: "VG",
    flag: "🇻🇬",
    id: "British Virgin Islands",
  },
  { name: "İran", dial_code: "+98", code: "IR", flag: "🇮🇷", id: "Iran" },
  { name: "İrlanda", dial_code: "+353", code: "IE", flag: "🇮🇪", id: "Ireland" },
  { name: "İspanya", dial_code: "+34", code: "ES", flag: "🇪🇸", id: "Spain" },
  { name: "İsrail", dial_code: "+972", code: "IL", flag: "🇮🇱", id: "Israel" },
  { name: "İsveç", dial_code: "+46", code: "SE", flag: "🇸🇪", id: "Sweden" },
  {
    name: "İsviçre",
    dial_code: "+41",
    code: "CH",
    flag: "🇨🇭",
    id: "Switzerland",
  },
  { name: "İtalya", dial_code: "+39", code: "IT", flag: "🇮🇹", id: "Italy" },
  { name: "İzlanda", dial_code: "+354", code: "IS", flag: "🇮🇸", id: "Iceland" },
  {
    name: "Jamaika",
    dial_code: "+1 876",
    code: "JM",
    flag: "🇯🇲",
    id: "Jamaica",
  },
  { name: "Japonya", dial_code: "+81", code: "JP", flag: "🇯🇵", id: "Japan" },
  {
    name: "Kamboçya",
    dial_code: "+855",
    code: "KH",
    flag: "🇰🇭",
    id: "Cambodia",
  },
  {
    name: "Kamerun",
    dial_code: "+237",
    code: "CM",
    flag: "🇨🇲",
    id: "Cameroon",
  },
  { name: "Kanada", dial_code: "+1", code: "CA", flag: "🇨🇦", id: "Canada" },
  {
    name: "Karadağ",
    dial_code: "+382",
    code: "ME",
    flag: "🇲🇪",
    id: "Montenegro",
  },
  { name: "Katar", dial_code: "+974", code: "QA", flag: "🇶🇦", id: "Qatar" },
  {
    name: "Kayman Adaları",
    dial_code: "+ 345",
    code: "KY",
    flag: "🇰🇾",
    id: "Cayman Islands",
  },
  {
    name: "Kazakistan",
    dial_code: "+7 7",
    code: "KZ",
    flag: "🇰🇿",
    id: "Kazakhstan",
  },
  { name: "Kenya", dial_code: "+254", code: "KE", flag: "🇰🇪", id: "Kenya" },
  {
    name: "Kiribati",
    dial_code: "+686",
    code: "KI",
    flag: "🇰🇮",
    id: "Kiribati",
  },
  {
    name: "Kolombiya",
    dial_code: "+57",
    code: "CO",
    flag: "🇨🇴",
    id: "Colombia",
  },
  {
    name: "Komorlar",
    dial_code: "+269",
    code: "KM",
    flag: "🇰🇲",
    id: "Comoros",
  },
  { name: "Kongo", dial_code: "+242", code: "CG", flag: "🇨🇬", id: "Congo" },
  {
    name: "Kongo Demokratik Cumhuriyeti",
    dial_code: "+243",
    code: "CD",
    flag: "🇨🇩",
    id: "Democratic Republic of the Congo",
  },
  {
    name: "Kosta Rika",
    dial_code: "+506",
    code: "CR",
    flag: "🇨🇷",
    id: "Costa Rica",
  },
  { name: "Kuveyt", dial_code: "+965", code: "KW", flag: "🇰🇼", id: "Kuwait" },
  {
    name: "Kuzey Kore",
    dial_code: "+850",
    code: "KP",
    flag: "🇰🇵",
    id: "North Korea",
  },
  {
    name: "Kuzey Mariana Adaları",
    dial_code: "+1 670",
    code: "MP",
    flag: "🇲🇵",
    id: "Northern Mariana Islands",
  },
  { name: "Küba", dial_code: "+53", code: "CU", flag: "🇨🇺", id: "Cuba" },
  {
    name: "Kırgızistan",
    dial_code: "+996",
    code: "KG",
    flag: "🇰🇬",
    id: "Kyrgyzstan",
  },
  { name: "Laos", dial_code: "+856", code: "LA", flag: "🇱🇦", id: "Laos" },
  { name: "Lesotho", dial_code: "+266", code: "LS", flag: "🇱🇸", id: "Lesotho" },
  { name: "Letonya", dial_code: "+371", code: "LV", flag: "🇱🇻", id: "Latvia" },
  { name: "Liberya", dial_code: "+231", code: "LR", flag: "🇱🇷", id: "Liberia" },
  { name: "Libya", dial_code: "+218", code: "LY", flag: "🇱🇾", id: "Libya" },
  {
    name: "Liechtenstein",
    dial_code: "+423",
    code: "LI",
    flag: "🇱🇮",
    id: "Liechtenstein",
  },
  {
    name: "Litvanya",
    dial_code: "+370",
    code: "LT",
    flag: "🇱🇹",
    id: "Lithuania",
  },
  { name: "Lübnan", dial_code: "+961", code: "LB", flag: "🇱🇧", id: "Lebanon" },
  {
    name: "Lüksemburg",
    dial_code: "+352",
    code: "LU",
    flag: "🇱🇺",
    id: "Luxembourg",
  },
  {
    name: "Macaristan",
    dial_code: "+36",
    code: "HU",
    flag: "🇭🇺",
    id: "Hungary",
  },
  {
    name: "Madagaskar",
    dial_code: "+261",
    code: "MG",
    flag: "🇲🇬",
    id: "Madagascar",
  },
  {
    name: "Makao S.A.R. Çin",
    dial_code: "+853",
    code: "MO",
    flag: "🇲🇴",
    id: "Macau",
  },
  {
    name: "Makedonya",
    dial_code: "+389",
    code: "MK",
    flag: "🇲🇰",
    id: "North Macedonia",
  },
  { name: "Malavi", dial_code: "+265", code: "MW", flag: "🇲🇼", id: "Malawi" },
  {
    name: "Maldivler",
    dial_code: "+960",
    code: "MV",
    flag: "🇲🇻",
    id: "Maldives",
  },
  { name: "Malezya", dial_code: "+60", code: "MY", flag: "🇲🇾", id: "Malaysia" },
  { name: "Mali", dial_code: "+223", code: "ML", flag: "🇲🇱", id: "Mali" },
  { name: "Malta", dial_code: "+356", code: "MT", flag: "🇲🇹", id: "Malta" },
  {
    name: "Marshall Adaları",
    dial_code: "+692",
    code: "MH",
    flag: "🇲🇭",
    id: "Marshall Islands",
  },
  {
    name: "Martinik",
    dial_code: "+596",
    code: "MQ",
    flag: "🇲🇶",
    id: "Martinique",
  },
  {
    name: "Mauritius",
    dial_code: "+230",
    code: "MU",
    flag: "🇲🇺",
    id: "Mauritius",
  },
  { name: "Mayotte", dial_code: "+262", code: "YT", flag: "🇾🇹", id: "Mayotte" },
  { name: "Meksika", dial_code: "+52", code: "MX", flag: "🇲🇽", id: "Mexico" },
  {
    name: "Mikronezya Federal Eyaletleri",
    dial_code: "+691",
    code: "FM",
    flag: "🇫🇲",
    id: "Federated States of Micronesia",
  },
  {
    name: "Moldovya Cumhuriyeti",
    dial_code: "+373",
    code: "MD",
    flag: "🇲🇩",
    id: "Moldova",
  },
  { name: "Monako", dial_code: "+377", code: "MC", flag: "🇲🇨", id: "Monaco" },
  {
    name: "Montserrat",
    dial_code: "+1664",
    code: "MS",
    flag: "🇲🇸",
    id: "Montserrat",
  },
  {
    name: "Moritanya",
    dial_code: "+222",
    code: "MR",
    flag: "🇲🇷",
    id: "Mauritania",
  },
  {
    name: "Mozambik",
    dial_code: "+258",
    code: "MZ",
    flag: "🇲🇿",
    id: "Mozambique",
  },
  {
    name: "Moğolistan",
    dial_code: "+976",
    code: "MN",
    flag: "🇲🇳",
    id: "Mongolia",
  },
  { name: "Myanmar", dial_code: "+95", code: "MM", flag: "🇲🇲", id: "Myanmar" },
  { name: "Mısır", dial_code: "+20", code: "EG", flag: "🇪🇬", id: "Egypt" },
  { name: "Namibya", dial_code: "+264", code: "NA", flag: "🇳🇦", id: "Namibia" },
  { name: "Nauru", dial_code: "+674", code: "NR", flag: "🇳🇷", id: "Nauru" },
  { name: "Nepal", dial_code: "+977", code: "NP", flag: "🇳🇵", id: "Nepal" },
  { name: "Nijer", dial_code: "+227", code: "NE", flag: "🇳🇪", id: "Niger" },
  { name: "Nijerya", dial_code: "+234", code: "NG", flag: "🇳🇬", id: "Nigeria" },
  {
    name: "Nikaragua",
    dial_code: "+505",
    code: "NI",
    flag: "🇳🇮",
    id: "Nicaragua",
  },
  { name: "Niue", dial_code: "+683", code: "NU", flag: "🇳🇺", id: "Niue" },
  {
    name: "Norfolk Adası",
    dial_code: "+672",
    code: "NF",
    flag: "🇳🇫",
    id: "Norfolk Island",
  },
  { name: "Norveç", dial_code: "+47", code: "NO", flag: "🇳🇴", id: "Norway" },
  {
    name: "Orta Afrika Cumhuriyeti",
    dial_code: "+236",
    code: "CF",
    flag: "🇨🇫",
    id: "Central African Republic",
  },
  {
    name: "Özbekistan",
    dial_code: "+998",
    code: "UZ",
    flag: "🇺🇿",
    id: "Uzbekistan",
  },
  {
    name: "Pakistan",
    dial_code: "+92",
    code: "PK",
    flag: "🇵🇰",
    id: "Pakistan",
  },
  { name: "Palau", dial_code: "+680", code: "PW", flag: "🇵🇼", id: "Palau" },
  { name: "Panama", dial_code: "+507", code: "PA", flag: "🇵🇦", id: "Panama" },
  {
    name: "Papua Yeni Gine",
    dial_code: "+675",
    code: "PG",
    flag: "🇵🇬",
    id: "Papua New Guinea",
  },
  {
    name: "Paraguay",
    dial_code: "+595",
    code: "PY",
    flag: "🇵🇾",
    id: "Paraguay",
  },
  { name: "Peru", dial_code: "+51", code: "PE", flag: "🇵🇪", id: "Peru" },
  {
    name: "Pitcairn",
    dial_code: "+872",
    code: "PN",
    flag: "🇵🇳",
    id: "Pitcairn",
  },
  { name: "Polonya", dial_code: "+48", code: "PL", flag: "🇵🇱", id: "Poland" },
  {
    name: "Portekiz",
    dial_code: "+351",
    code: "PT",
    flag: "🇵🇹",
    id: "Portugal",
  },
  {
    name: "Porto Riko",
    dial_code: "+1 939",
    code: "PR",
    flag: "🇵🇷",
    id: "Puerto Rico",
  },
  { name: "Reunion", dial_code: "+262", code: "RE", flag: "🇷🇪", id: "Réunion" },
  { name: "Romanya", dial_code: "+40", code: "RO", flag: "🇷🇴", id: "Romania" },
  { name: "Ruanda", dial_code: "+250", code: "RW", flag: "🇷🇼", id: "Rwanda" },
  {
    name: "Rusya Federasyonu",
    dial_code: "+7",
    code: "RU",
    flag: "🇷🇺",
    id: "Russia",
  },
  { name: "Samoa", dial_code: "+685", code: "WS", flag: "🇼🇸", id: "Samoa" },
  {
    name: "San Marino",
    dial_code: "+378",
    code: "SM",
    flag: "🇸🇲",
    id: "San Marino",
  },
  {
    name: "Sao Tome ve Principe",
    dial_code: "+239",
    code: "ST",
    flag: "🇸🇹",
    id: "Sao Tome and Principe",
  },
  { name: "Senegal", dial_code: "+221", code: "SN", flag: "🇸🇳", id: "Senegal" },
  {
    name: "Seyşeller",
    dial_code: "+248",
    code: "SC",
    flag: "🇸🇨",
    id: "Seychelles",
  },
  {
    name: "Sierra Leone",
    dial_code: "+232",
    code: "SL",
    flag: "🇸🇱",
    id: "Sierra Leone",
  },
  {
    name: "Singapur",
    dial_code: "+65",
    code: "SG",
    flag: "🇸🇬",
    id: "Singapore",
  },
  {
    name: "Slovakya",
    dial_code: "+421",
    code: "SK",
    flag: "🇸🇰",
    id: "Slovakia",
  },
  {
    name: "Slovenya",
    dial_code: "+386",
    code: "SI",
    flag: "🇸🇮",
    id: "Slovenia",
  },
  {
    name: "Solomon Adaları",
    dial_code: "+677",
    code: "SB",
    flag: "🇸🇧",
    id: "Solomon Islands",
  },
  { name: "Somali", dial_code: "+252", code: "SO", flag: "🇸🇴", id: "Somalia" },
  {
    name: "Sri Lanka",
    dial_code: "+94",
    code: "LK",
    flag: "🇱🇰",
    id: "Sri Lanka",
  },
  { name: "Sudan", dial_code: "+249", code: "SD", flag: "🇸🇩", id: "Sudan" },
  {
    name: "Surinam",
    dial_code: "+597",
    code: "SR",
    flag: "🇸🇷",
    id: "Suriname",
  },
  { name: "Suriye", dial_code: "+963", code: "SY", flag: "🇸🇾", id: "Syria" },
  {
    name: "Suudi Arabistan",
    dial_code: "+966",
    code: "SA",
    flag: "🇸🇦",
    id: "Saudi Arabia",
  },
  {
    name: "Svaziland",
    dial_code: "+268",
    code: "SZ",
    flag: "🇸🇿",
    id: "Eswatini",
  },
  {
    name: "Sırbistan",
    dial_code: "+381",
    code: "RS",
    flag: "🇷🇸",
    id: "Serbia",
  },
  { name: "Şili", dial_code: "+56", code: "CL", flag: "🇨🇱", id: "Chile" },
  {
    name: "Tacikistan",
    dial_code: "+992",
    code: "TJ",
    flag: "🇹🇯",
    id: "Tajikistan",
  },
  {
    name: "Tanzanya",
    dial_code: "+255",
    code: "TZ",
    flag: "🇹🇿",
    id: "Tanzania",
  },
  { name: "Tayland", dial_code: "+66", code: "TH", flag: "🇹🇭", id: "Thailand" },
  { name: "Tayvan", dial_code: "+886", code: "TW", flag: "🇹🇼", id: "Taiwan" },
  { name: "Togo", dial_code: "+228", code: "TG", flag: "🇹🇬", id: "Togo" },
  { name: "Tokelau", dial_code: "+690", code: "TK", flag: "🇹🇰", id: "Tokelau" },
  { name: "Tonga", dial_code: "+676", code: "TO", flag: "🇹🇴", id: "Tonga" },
  {
    name: "Trinidad ve Tobago",
    dial_code: "+1 868",
    code: "TT",
    flag: "🇹🇹",
    id: "Trinidad and Tobago",
  },
  { name: "Tunus", dial_code: "+216", code: "TN", flag: "🇹🇳", id: "Tunisia" },
  {
    name: "Turks ve Caicos Adaları",
    dial_code: "+1 649",
    code: "TC",
    flag: "🇹🇨",
    id: "Turks and Caicos Islands",
  },
  { name: "Tuvalu", dial_code: "+688", code: "TV", flag: "🇹🇻", id: "Tuvalu" },
  { name: "Türkiye", dial_code: "+90", code: "TR", flag: "🇹🇷", id: "Turkey" },
  {
    name: "Türkmenistan",
    dial_code: "+993",
    code: "TM",
    flag: "🇹🇲",
    id: "Turkmenistan",
  },
  { name: "Uganda", dial_code: "+256", code: "UG", flag: "🇺🇬", id: "Uganda" },
  { name: "Ukrayna", dial_code: "+380", code: "UA", flag: "🇺🇦", id: "Ukraine" },
  { name: "Umman", dial_code: "+968", code: "OM", flag: "🇴🇲", id: "Oman" },
  { name: "Uruguay", dial_code: "+598", code: "UY", flag: "🇺🇾", id: "Uruguay" },
  { name: "Ürdün", dial_code: "+962", code: "JO", flag: "🇯🇴", id: "Jordan" },
  { name: "Vanuatu", dial_code: "+678", code: "VU", flag: "🇻🇺", id: "Vanuatu" },
  {
    name: "Vatikan",
    dial_code: "+379",
    code: "VA",
    flag: "🇻🇦",
    id: "Vatican City",
  },
  {
    name: "Venezuela",
    dial_code: "+58",
    code: "VE",
    flag: "🇻🇪",
    id: "Venezuela",
  },
  { name: "Vietnam", dial_code: "+84", code: "VN", flag: "🇻🇳", id: "Vietnam" },
  {
    name: "Wallis ve Futuna",
    dial_code: "+681",
    code: "WF",
    flag: "🇼🇫",
    id: "Wallis and Futuna",
  },
  { name: "Yemen", dial_code: "+967", code: "YE", flag: "🇾🇪", id: "Yemen" },
  {
    name: "Yeni Kaledonya",
    dial_code: "+687",
    code: "NC",
    flag: "🇳🇨",
    id: "New Caledonia",
  },
  {
    name: "Yeni Zelanda",
    dial_code: "+64",
    code: "NZ",
    flag: "🇳🇿",
    id: "New Zealand",
  },
  {
    name: "Yunanistan",
    dial_code: "+30",
    code: "GR",
    flag: "🇬🇷",
    id: "Greece",
  },
  { name: "Zambiya", dial_code: "+260", code: "ZM", flag: "🇿🇲", id: "Zambia" },
  {
    name: "Zimbabve",
    dial_code: "+263",
    code: "ZW",
    flag: "🇿🇼",
    id: "Zimbabwe",
  },
];

export const TRANSACTION_STATUS = [
  {
    label: "Draft",
    value: "Draft",
    translationKey: "draft",
    icon: <FileEdit size={16} color="currentColor" />,
    variant: "secondary",
    color: "#96c9fb",
  },
  {
    label: "Pending",
    value: "Pending",
    translationKey: "pending",
    icon: <Warning size={16} color="currentColor" />,
    variant: "warning",
    color: "#F6B11A",
  },
  {
    label: "Completed",
    value: "Completed",
    translationKey: "completed",
    icon: <RiCheckboxCircleFill size={16} color="currentColor" />,
    variant: "success",
    color: "#1BE368",
  },
  {
    label: "Failed",
    value: "Failed",
    translationKey: "failed",
    icon: <RiErrorWarningFill size={16} color="currentColor" />,
    variant: "danger",
    isHidden: true,
    color: "#FD4B4B",
  },
  {
    label: "Cancelled",
    value: "Cancelled",
    translationKey: "cancelled",
    icon: <RiCloseCircleFill size={16} color="currentColor" />,
    variant: "danger",
    color: "#f884f4",
  },
  {
    label: "Scheduled",
    value: "Scheduled",
    translationKey: "scheduled",
    icon: <RiCalendarCheckLine size={16} color="currentColor" />,
    variant: "primary",
    isHidden: true,
    color: "#6bf8e8",
  },
  {
    label: "Overdue",
    value: "Overdue",
    translationKey: "overdue",
    icon: <RiHistoryLine size={16} color="currentColor" />,
    variant: "info",
    isHidden: true,
    color: "#917ff9",
  },
].filter((status) => !status.isHidden);

export const INVOICE_STATUS = [
  {
    label: "Draft",
    value: "Draft",
    translationKey: "draft",
    icon: <FileEdit size={16} color="currentColor" />,
    variant: "secondary",
    color: "#96c9fb",
  },
  {
    label: "Pending Approval",
    value: "PendingApproval",
    translationKey: "pending_approval",
    icon: <Warning size={16} color="currentColor" />,
    variant: "warning",
    color: "#F6B11A",
  },
  {
    label: "Payment Pending",
    value: "Approved",
    translationKey: "payment_pending",
    icon: <RiCheckboxCircleFill size={16} color="currentColor" />,
    variant: "success",
    color: "#1BE368",
  },
  {
    label: "Rejected",
    value: "Rejected",
    translationKey: "rejected",
    icon: <RiCloseCircleFill size={16} color="currentColor" />,
    variant: "danger",
    color: "#FD4B4B",
  },
  {
    label: "Partially Paid",
    value: "PartiallyPaid",
    translationKey: "partially_paid",
    icon: <RiHistoryLine size={16} color="currentColor" />,
    variant: "info",
    color: "#917ff9",
  },
  {
    label: "Paid",
    value: "Paid",
    translationKey: "fully_paid",
    icon: <RiCheckboxCircleFill size={16} color="currentColor" />,
    variant: "success",
    color: "#1BE368",
  },
  {
    label: "Completed",
    value: "Completed",
    translationKey: "completed",
    icon: <RiCheckboxCircleFill size={16} color="currentColor" />,
    variant: "success",
    color: "#1BE368",
  },
  {
    label: "Cancelled",
    value: "Cancelled",
    translationKey: "cancelled",
    icon: <RiCloseCircleFill size={16} color="currentColor" />,
    variant: "danger",
    color: "#f884f4",
  },
  {
    label: "Payment Order Exported",
    value: "PaymentPending",
    translationKey: "payment_order_exported",
    icon: <RiHistoryLine size={16} color="currentColor" />,
    variant: "info",
    color: "#917ff9",
  },
  {
    label: "Overdue",
    value: "Overdue",
    translationKey: "overdue",
    icon: <RiErrorWarningFill size={16} color="currentColor" />,
    variant: "info",
    color: "#917ff9",
  },
];

export const ACCOUNT_TYPES = [
  { label: "Cash", value: "Cash", translationKey: "cash", icon: RiCashLine },
  {
    label: "Bank Account",
    value: "BankAccount",
    translationKey: "bank_account",
    icon: RiBankLine,
  },
  {
    label: "Credit Card",
    value: "CreditCard",
    translationKey: "credit_card",
    icon: RiBankCardLine,
  },
  {
    label: "Investment",
    value: "Investment",
    translationKey: "investment",
    icon: RiCommunityLine,
  },
  { label: "Loan", value: "Loan", translationKey: "loan", icon: RiPercentLine },
  {
    label: "Asset",
    value: "Asset",
    translationKey: "asset",
    icon: RiVipDiamondLine,
  },
  {
    label: "Liability",
    value: "Liability",
    translationKey: "liability",
    icon: RiFileList3Line,
  },
  {
    label: "Crypto",
    value: "Crypto",
    translationKey: "crypto",
    icon: RiBtcLine,
  },
  {
    label: "Other",
    value: "Other",
    translationKey: "other",
    icon: RiCoupon3Line,
  },
];

export const APP_TYPE: Record<string, string> = {
  MOBILE: "mobile",
  ADMIN: "admin",
};

export const MaintenanceScheduleTypes = [
  {
    label: "NonRecurringDate",
    value: "NonRecurringDate",
    translationKey: "nonRecurringDate",
  },
  {
    label: "NonRecurringRunningHours",
    value: "NonRecurringRunningHours",
    translationKey: "nonRecurringRunningHours",
  },
  {
    label: "NonRecurringCombined",
    value: "NonRecurringCombined",
    translationKey: "nonRecurringCombined",
  },
  {
    label: "RecurringCalendar",
    value: "RecurringCalendar",
    translationKey: "recurringCalendar",
  },
  {
    label: "RecurringRunningHours",
    value: "RecurringRunningHours",
    translationKey: "recurringRunningHours",
  },
  {
    label: "RecurringCombined",
    value: "RecurringCombined",
    translationKey: "recurringCombined",
  },
] as const;

export const MaintenanceScheduleTypesMap = MaintenanceScheduleTypes.reduce(
  (acc, type) => {
    acc[type.value as MaintenanceScheduleType] = type.translationKey;
    return acc;
  },
  {} as Record<MaintenanceScheduleType, string>
);
